module.exports = __webpack_public_path__ + "img/mobile_home.20a82375.svg";